/* heading-item.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1n3s%7Bcolor%3Avar(--ds-text-subtle%2C%235e6c84)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18zrpxbi%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rjcze3t%7Bpadding-block%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8i4vh%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
import { memo } from 'react';
import { N300 } from '@atlaskit/theme/colors';
import type { HeadingItemProps } from '../types';
const headingStyles = null;

/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
const HeadingItem: import("react").MemoExoticComponent<({
  children,
  testId,
  headingLevel,
  id,
  className: UNSAFE_className,
  ...rest
}: HeadingItemProps) => JSX.Element> = memo(({
  children,
  testId,
  headingLevel = 2,
  id,
  // Although this isn't defined on props it is available because we've used
  // Spread props below and on the jsx element. To forcibly block usage I've
  // picked it out and supressed the expected type error.
  // @ts-expect-error
  className: UNSAFE_className,
  ...rest
}: HeadingItemProps) => {
  return <div role="heading" aria-level={headingLevel} data-testid={testId} data-ds--menu--heading-item id={id}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax(["_11c8i4vh _1rjcze3t _18zrpxbi _syaz1n3s", UNSAFE_className])} {...rest}>
				{children}
			</div>;
});
export default HeadingItem;